// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import SearchLessonsWithModulesRequestModel from '../../model/search-lessons-with-modules-request-model';
import SearchLessonsWithModulesRequestDTO from '../dto/search-lessons-with-modules-request-dto';
import dtoSchema from '../schemas/search-lessons-with-modules-request-schema';

export default abstract class SearchLessonsWithModulesRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<SearchLessonsWithModulesRequestDTO>) {
    super();
    this.paging = {};
    if (data) {
      this.paging = {
        currentPage: data['paging.CurrentPage'],
        pageSize: data['paging.PageSize'],
        includeCount: data['paging.IncludeCount'],
        noPaging: data['paging.NoPaging'],
      };
      this.classYear = data.classYear;
      this.moduleIds = data.moduleIds;
      this.classIds = data.classIds;
      this.lectureLessonStatusIds = data.lectureLessonStatusIds;
      this.eventTypeIds = data.eventTypeIds;
      this.userId = data.userId;
      this.lecturerId = data.lecturerId;
      this.primaryLeadLecturerId = data.primaryLeadLecturerId;
      this.isPrototype = data.isPrototype;
      this.searchCriteria = data.searchCriteria;
    }
  }

  paging: {
    /**
    * @type {int32}
    */
    currentPage?: number;
    /**
    * @type {int32}
    */
    pageSize?: number;
    /**
    */
    includeCount?: boolean;
    /**
    */
    noPaging?: boolean;
  };

  /**
  * @type {int32}
  */
  classYear?: number;
  /**
  */
  moduleIds?: number[];
  /**
  */
  classIds?: number[];
  /**
  */
  lectureLessonStatusIds?: number[];
  /**
  */
  eventTypeIds?: number[];
  /**
  * @type {int64}
  */
  userId?: number;
  /**
  * @type {int64}
  */
  lecturerId?: number;
  /**
  * @type {int64}
  */
  primaryLeadLecturerId?: number;
  /**
  */
  isPrototype?: boolean;
  /**
  */
  searchCriteria?: string;

  static toModel(dto: DeepPartial<SearchLessonsWithModulesRequestDTO>): SearchLessonsWithModulesRequestModel;
  static toModel(dto: DeepPartial<SearchLessonsWithModulesRequestDTO> | undefined | null): SearchLessonsWithModulesRequestModel | undefined;
  static toModel(dto: DeepPartial<SearchLessonsWithModulesRequestDTO> | undefined | null): SearchLessonsWithModulesRequestModel | undefined {
    return dto ? new SearchLessonsWithModulesRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<SearchLessonsWithModulesRequestModel> | SearchLessonsWithModulesRequestModel): SearchLessonsWithModulesRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      'paging.CurrentPage': unwrapped.paging?.currentPage,
      'paging.PageSize': unwrapped.paging?.pageSize,
      'paging.IncludeCount': unwrapped.paging?.includeCount,
      'paging.NoPaging': unwrapped.paging?.noPaging,
      classYear: unwrapped.classYear,
      moduleIds: unwrapped.moduleIds,
      classIds: unwrapped.classIds,
      lectureLessonStatusIds: unwrapped.lectureLessonStatusIds,
      eventTypeIds: unwrapped.eventTypeIds,
      userId: unwrapped.userId,
      lecturerId: unwrapped.lecturerId,
      primaryLeadLecturerId: unwrapped.primaryLeadLecturerId,
      isPrototype: unwrapped.isPrototype,
      searchCriteria: unwrapped.searchCriteria,
    } as SearchLessonsWithModulesRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for SearchLessonsWithModulesRequestModel, can not map to SearchLessonsWithModulesRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
